import { render, staticRenderFns } from "./validation-messages.vue?vue&type=template&id=70159058"
import script from "./validation-messages.vue?vue&type=script&lang=js"
export * from "./validation-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports